export default {
  breakpoints: {
    xs: '400px',
    sm: '640px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
  },
}
